enum VendorListContentType {
  Jobs = 'Jobs',
  Candidates = 'Candidates',
  JobsAndCandidates = 'JobsAndCandidates',
}
export default VendorListContentType;
